export const BACKOFFICE_ORGANIZATIONS_EMPLOYEE_CENTER = {
  DESCRIPTION: 'Choose which documents this organization shows its employees in the Employee Center.',
  VISIBLE_TOOLTIP:
    'Turning a document on makes it eligible. It reaches employees once it is translated into this ' +
    "organization's language and has an approved version, or a usable document link for " +
    'organizations still on Drive.',
  ALL_DEPARTMENTS: 'All departments',
  NO_APPROVED_VERSION: 'On, but not yet shown: no approved version',
  MISSING_TRANSLATION: "On, but not yet shown: no translation in this organization's language",
  ENABLED_COUNT: '{count} shown to employees',
  HIDDEN_BY_FILTER: '{count} enabled outside this filter',
  NEVER_REVIEWED: '{count} never reviewed',
  NEVER_REVIEWED_OTHER_TYPES: 'Documents in {count} other types have never been reviewed',
  SHOW_ALL_TYPES: 'Show all types',
  ENABLE_ALL_IN_VIEW: 'Enable all shown',
  ENABLING: 'Enabling...',
  ALL_TYPES: 'All types',
  SEARCH_PLACEHOLDER: 'Search by code or name...',
  LOADING: 'Loading...',
  REFRESH: 'Refresh',
  EMPTY: 'No documents match.',
  TABLE: {
    CODE: 'Code',
    NAME: 'Name',
    TYPE: 'Type',
    STATUS: 'Status',
    VISIBLE: 'Employee Center',
    DEPARTMENTS: 'Departments',
  },
  SNACKBAR: {
    SAVED: 'Changes saved',
  },
}
